module.exports = __webpack_public_path__ + "img/01.a4342a3d.png";